function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 */

import { onFrame, performanceNow } from "./util";

/**
 * Plays each frame of the SpringSystem on animation
 * timing loop. This is the default type of looper for a new spring system
 * as it is the most common when developing UI.
 * @public
 */
export var AnimationLooper = function () {
  function AnimationLooper() {
    _classCallCheck(this, AnimationLooper);
  }

  AnimationLooper.prototype.run = function run() {
    var _this = this;

    onFrame(function () {
      _this.springSystem.loop(performanceNow());
    });
  };

  return AnimationLooper;
}();